// extracted by mini-css-extract-plugin
export default {"day":"CalendarDay_day__xoZ+o","disabled":"CalendarDay_disabled__J20kY","selected":"CalendarDay_selected__WelzR"};